import { AfterViewInit, Component, ElementRef, inject, viewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { DevNotesService } from '../../../shared/dev-notes/dev-notes.service';

/**
 * Floating, draggable notes scratchpad opened by DevNotesService. Internal
 * staff only (behind the `~` dev menu / Ctrl+Alt+N), so its strings skip
 * Tolgee like the rest of the dev command menu.
 */
@Component({
  selector: 'app-dev-notes-panel',
  imports: [FormsModule, CdkDrag, CdkDragHandle, MatIconModule, MatButtonModule],
  templateUrl: './dev-notes-panel.html',
  styleUrl: './dev-notes-panel.scss',
  host: { '(keydown.escape)': 'onEscape($event)' },
})
export class DevNotesPanel implements AfterViewInit {
  protected readonly notes = inject(DevNotesService);
  private readonly textarea = viewChild<ElementRef<HTMLTextAreaElement>>('textarea');

  ngAfterViewInit(): void {
    this.textarea()?.nativeElement.focus();
  }

  protected close(): void {
    this.notes.close();
  }

  /**
   * Closes the notes only. Stopping the event keeps it from reaching the CDK
   * overlay keyboard dispatcher, which would otherwise also close a dialog
   * the notes are floating over.
   */
  protected onEscape(event: Event): void {
    event.stopPropagation();
    this.notes.close();
  }
}
